/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum BatchJobStatus {
  complete = "complete",
  pending = "pending",
}

export enum ChangeReason {
  company_changed = "company_changed",
  eci = "eci",
  eco = "eco",
  guest_declined = "guest_declined",
  inquiry_extension = "inquiry_extension",
  inquiry_not_booked = "inquiry_not_booked",
  inquiry_reduction = "inquiry_reduction",
  inquiry_relocation = "inquiry_relocation",
  lco = "lco",
  new_booking = "new_booking",
  not_within_clean_creation_cutoff_time = "not_within_clean_creation_cutoff_time",
  reason_unknown = "reason_unknown",
  restored_check_out = "restored_check_out",
  set_to_default_cleaning_window = "set_to_default_cleaning_window",
  sync_with_tom = "sync_with_tom",
  unit_mismatch = "unit_mismatch",
  unit_not_assigned = "unit_not_assigned",
  user = "user",
}

export enum ChecklistItemStatus {
  active = "active",
  completed = "completed",
  deleted = "deleted",
}

export enum CleanShuffleDetailStatus {
  failed = "failed",
  not_changed = "not_changed",
  successful = "successful",
}

export enum CleaningRequestCategory {
  checkout = "checkout",
  checkout_plus = "checkout_plus",
  deep = "deep",
  intrastay = "intrastay",
  re_clean = "re_clean",
  set_up = "set_up",
  space_clean = "space_clean",
  stayover = "stayover",
  touch_up_turnover = "touch_up_turnover",
}

export enum CleaningRequestStatus {
  cancelled = "cancelled",
  completed = "completed",
  pending = "pending",
  scheduled = "scheduled",
}

export enum CleaningWindow {
  early_afternoon = "early_afternoon",
  late_afternoon = "late_afternoon",
  morning = "morning",
}

export enum ConnectedSpacesMaintenanceTypeEnum {
  backup_code_rotation_failed = "backup_code_rotation_failed",
  change_battery = "change_battery",
  check_hub_connection = "check_hub_connection",
  fix_lock_alignment = "fix_lock_alignment",
  lock_tampered = "lock_tampered",
  revive_dead_hub = "revive_dead_hub",
}

export enum DaysOfWeek {
  friday = "friday",
  monday = "monday",
  saturday = "saturday",
  sunday = "sunday",
  thursday = "thursday",
  tuesday = "tuesday",
  wednesday = "wednesday",
}

export enum DispatchRoleName {
  hk_contractor = "hk_contractor",
  hk_manager = "hk_manager",
  housekeeper = "housekeeper",
  tom_manager = "tom_manager",
  tom_team_lead = "tom_team_lead",
}

export enum EciLcoStatus {
  approved = "approved",
  approved_pending_payment = "approved_pending_payment",
  cancelled = "cancelled",
  missed = "missed",
  pending = "pending",
  rejected = "rejected",
}

export enum FilesAttachable {
  comment = "comment",
  task = "task",
  user = "user",
}

export enum FilterClient {
  get = "get",
  ops = "ops",
}

export enum FilterDropOffLocation {
  office = "office",
  unit = "unit",
}

export enum FilterDuringStay {
  during_stay = "during_stay",
}

export enum FilterEtaEnabled {
  no = "no",
  yes = "yes",
}

export enum FilterOccupancy {
  occupied = "occupied",
  vacant = "vacant",
}

export enum FilterOwner {
  city = "city",
}

export enum FilterPTE {
  guest_informed = "guest_informed",
  no = "no",
  yes = "yes",
}

export enum FilterStatus {
  arriving = "arriving",
  canceled = "canceled",
  complete = "complete",
  deleted = "deleted",
  enroute = "enroute",
  incomplete = "incomplete",
  inprogress = "inprogress",
  ready = "ready",
  waiting = "waiting",
}

export enum FilterTriaged {
  new = "new",
  triaged = "triaged",
}

export enum Format {
  amr = "amr",
  avi = "avi",
  gif = "gif",
  heic = "heic",
  jpg = "jpg",
  m4a = "m4a",
  mov = "mov",
  mp4 = "mp4",
  pdf = "pdf",
  png = "png",
  tiff = "tiff",
  webp = "webp",
}

export enum GuestAlreadyAware {
  no = "no",
  yes = "yes",
}

export enum GuestIssueTypeEnum {
  access = "access",
  air_conditioning = "air_conditioning",
  broken_appliance = "broken_appliance",
  broken_furniture_or_amenities = "broken_furniture_or_amenities",
  bugs_or_rodents = "bugs_or_rodents",
  cable = "cable",
  cleanliness = "cleanliness",
  electrical = "electrical",
  heat = "heat",
  internet = "internet",
  missing_item_or_amenity = "missing_item_or_amenity",
  noise_complaint = "noise_complaint",
  parking = "parking",
  plumbing = "plumbing",
  stained_or_damaged_linens = "stained_or_damaged_linens",
}

export enum GuestReceivedPreviousWarning {
  no = "no",
  yes = "yes",
}

export enum GuestRequestTypeEnum {
  amenities = "amenities",
  fan = "fan",
  forgotten_personal_item = "forgotten_personal_item",
  furniture = "furniture",
  groceries = "groceries",
  heater = "heater",
  high_chair = "high_chair",
  intrastay_cleaning = "intrastay_cleaning",
  noise_machine = "noise_machine",
  pack_and_play = "pack_and_play",
  package_or_mail = "package_or_mail",
  sheets = "sheets",
  special_occasion = "special_occasion",
}

export enum GuestUrgency {
  high = "high",
  low = "low",
  medium = "medium",
}

export enum InquiryCheckoutSortColumn {
  check_out_time = "check_out_time",
  unit_internal_ref = "unit_internal_ref",
}

export enum InquiryCheckoutStatus {
  checked_out = "checked_out",
  not_checked_out = "not_checked_out",
  past_checkout_time = "past_checkout_time",
}

export enum InternalUnitTaskSubTypeEnum {
  access = "access",
  air_conditioning = "air_conditioning",
  broken_appliance = "broken_appliance",
  broken_furniture_or_amenities = "broken_furniture_or_amenities",
  bugs_or_rodents = "bugs_or_rodents",
  cable = "cable",
  cleanliness = "cleanliness",
  electrical = "electrical",
  garbage_collection = "garbage_collection",
  heat = "heat",
  internet = "internet",
  missing_item_or_amenity = "missing_item_or_amenity",
  other_maintenance = "other_maintenance",
  plumbing = "plumbing",
  showing_or_open_house = "showing_or_open_house",
  stained_or_damaged_linens = "stained_or_damaged_linens",
  update_cuf = "update_cuf",
}

export enum NotificationReason {
  assignee = "assignee",
  buildingSupervisor = "buildingSupervisor",
  hkManager = "hkManager",
  lead = "lead",
  mention = "mention",
  parentAssignee = "parentAssignee",
  previousAssignee = "previousAssignee",
  subscriber = "subscriber",
}

export enum NotificationResource {
  task = "task",
  unit = "unit",
}

export enum ReasonForBan {
  abusive_behavior = "abusive_behavior",
  assault_physical_violence = "assault_physical_violence",
  commercial_activity = "commercial_activity",
  failed_background_check = "failed_background_check",
  firearms_other_weapons_possession = "firearms_other_weapons_possession",
  fraud = "fraud",
  heavy_physical_damage = "heavy_physical_damage",
  illegal_drug_activity = "illegal_drug_activity",
  light_physical_damage = "light_physical_damage",
  party = "party",
  pets = "pets",
  smoking = "smoking",
  theft_break_in_trespassing = "theft_break_in_trespassing",
}

export enum ReasonForEjection {
  damages = "damages",
  fraud = "fraud",
  inappropriate_guest_behavior = "inappropriate_guest_behavior",
  violation_of_sonder_house_rules = "violation_of_sonder_house_rules",
}

export enum ReasonForRelocation {
  access = "access",
  accommodating_booking_extension = "accommodating_booking_extension",
  bed_bug_or_vermin = "bed_bug_or_vermin",
  cleanliness = "cleanliness",
  double_booked = "double_booked",
  missing_or_broken_item_appliance = "missing_or_broken_item_appliance",
  need_to_accommodate_ltr = "need_to_accommodate_ltr",
  off_boarding = "off_boarding",
  other_reason_specify = "other_reason_specify",
  pending_maintenance_repairs = "pending_maintenance_repairs",
  plumbing_hvac_issue = "plumbing_hvac_issue",
  shuffling_unit_does_not_meet_guest_expectations = "shuffling_unit_does_not_meet_guest_expectations",
  specific_unit_desired = "specific_unit_desired",
  switch_buildings_locations = "switch_buildings_locations",
  to_downgrade_space = "to_downgrade_space",
  to_upgrade_space = "to_upgrade_space",
}

export enum RecurrenceIntervalUnit {
  day = "day",
  month = "month",
  week = "week",
}

export enum RequestedCleaningTimeSlot {
  early_afternoon = "early_afternoon",
  late_afternoon = "late_afternoon",
  morning = "morning",
}

export enum Resource {
  image = "image",
  video = "video",
}

export enum Result {
  building = "building",
  inquiry = "inquiry",
  lease_inquiry = "lease_inquiry",
  space = "space",
  task = "task",
  task_context = "task_context",
  unit = "unit",
  user = "user",
}

export enum SecurityOnsite {
  no = "no",
  yes = "yes",
}

export enum SortAscDesc {
  asc = "asc",
  desc = "desc",
}

export enum SortColumn {
  cleaning_actual_end_at = "cleaning_actual_end_at",
  cleaning_company_name = "cleaning_company_name",
  created_at = "created_at",
  hk_misc_service_date = "hk_misc_service_date",
}

export enum SourceOfRelocationRequest {
  guest = "guest",
  sonder = "sonder",
}

export enum SquadTag {
  Dispatch = "Dispatch",
  ExternalHousekeeping = "ExternalHousekeeping",
  GET = "GET",
  Hotel = "Hotel",
  IT = "IT",
  InternalHousekeeping = "InternalHousekeeping",
  Landlord = "Landlord",
  MaintenancePM = "MaintenancePM",
  Onboarding = "Onboarding",
  Procurement = "Procurement",
  Warehouse = "Warehouse",
}

export enum TaskContextSubjectTypeEnum {
  Building = "Building",
  Cuf_Space = "Cuf_Space",
  Inquiry = "Inquiry",
  LeaseInquiry = "LeaseInquiry",
  Unit = "Unit",
}

export enum TaskLocationPlaceEnum {
  Building = "Building",
  Space = "Space",
  Unit = "Unit",
}

export enum TaskScheduleStatusEnum {
  all = "all",
  scheduled = "scheduled",
  unscheduled = "unscheduled",
}

export enum TaskSortColumn {
  assignee_id = "assignee_id",
  assignee_name = "assignee_name",
  due_at = "due_at",
  internal_ref = "internal_ref",
  name = "name",
  occupancy = "occupancy",
  priority = "priority",
  status = "status",
  task_completed_at = "task_completed_at",
}

export enum TaskStatus {
  arriving = "arriving",
  canceled = "canceled",
  complete = "complete",
  deleted = "deleted",
  enroute = "enroute",
  inprogress = "inprogress",
  ready = "ready",
  waiting = "waiting",
}

export enum TypeEnum {
  GetFollowup = "GetFollowup",
  Tom_Tasks_Booking = "Tom_Tasks_Booking",
  Tom_Tasks_Clean = "Tom_Tasks_Clean",
  Tom_Tasks_ConnectedSpacesMaintenance = "Tom_Tasks_ConnectedSpacesMaintenance",
  Tom_Tasks_CreateLeaseCharge = "Tom_Tasks_CreateLeaseCharge",
  Tom_Tasks_CreateMasterLeaseRecord = "Tom_Tasks_CreateMasterLeaseRecord",
  Tom_Tasks_DirtyCheckInWarning = "Tom_Tasks_DirtyCheckInWarning",
  Tom_Tasks_EarlyCheckIn = "Tom_Tasks_EarlyCheckIn",
  Tom_Tasks_EciLcoFollowup = "Tom_Tasks_EciLcoFollowup",
  Tom_Tasks_GetFollowup = "Tom_Tasks_GetFollowup",
  Tom_Tasks_GetRelocation = "Tom_Tasks_GetRelocation",
  Tom_Tasks_GuestInUnitAfterCheckout = "Tom_Tasks_GuestInUnitAfterCheckout",
  Tom_Tasks_GuestIssue = "Tom_Tasks_GuestIssue",
  Tom_Tasks_GuestRequest = "Tom_Tasks_GuestRequest",
  Tom_Tasks_GuestRequestAmenities = "Tom_Tasks_GuestRequestAmenities",
  Tom_Tasks_HoldSecurityDeposit = "Tom_Tasks_HoldSecurityDeposit",
  Tom_Tasks_InPersonCheckIn = "Tom_Tasks_InPersonCheckIn",
  Tom_Tasks_Inspection = "Tom_Tasks_Inspection",
  Tom_Tasks_InspectionTask = "Tom_Tasks_InspectionTask",
  Tom_Tasks_InternalHoldChecklist = "Tom_Tasks_InternalHoldChecklist",
  Tom_Tasks_InternalInquiryTask = "Tom_Tasks_InternalInquiryTask",
  Tom_Tasks_InternalSubtask = "Tom_Tasks_InternalSubtask",
  Tom_Tasks_InternalUnitTask = "Tom_Tasks_InternalUnitTask",
  Tom_Tasks_IntrastayCheck = "Tom_Tasks_IntrastayCheck",
  Tom_Tasks_Issue = "Tom_Tasks_Issue",
  Tom_Tasks_KeycafeKeyMissingNotification = "Tom_Tasks_KeycafeKeyMissingNotification",
  Tom_Tasks_LateCheckOut = "Tom_Tasks_LateCheckOut",
  Tom_Tasks_LeaseBillingSchedule = "Tom_Tasks_LeaseBillingSchedule",
  Tom_Tasks_LongTermCheckIn = "Tom_Tasks_LongTermCheckIn",
  Tom_Tasks_LongTermCheckOut = "Tom_Tasks_LongTermCheckOut",
  Tom_Tasks_LongTermNycCheckInSubTask = "Tom_Tasks_LongTermNycCheckInSubTask",
  Tom_Tasks_LongTermNycCheckOutSubTask = "Tom_Tasks_LongTermNycCheckOutSubTask",
  Tom_Tasks_LongTermPreCheckIn = "Tom_Tasks_LongTermPreCheckIn",
  Tom_Tasks_LongTermPreCheckOut = "Tom_Tasks_LongTermPreCheckOut",
  Tom_Tasks_LongTermScheduleCleaning = "Tom_Tasks_LongTermScheduleCleaning",
  Tom_Tasks_LongTermStay = "Tom_Tasks_LongTermStay",
  Tom_Tasks_LongTermSubTask = "Tom_Tasks_LongTermSubTask",
  Tom_Tasks_LuggageDropOff = "Tom_Tasks_LuggageDropOff",
  Tom_Tasks_MaintenanceInspectionTask = "Tom_Tasks_MaintenanceInspectionTask",
  Tom_Tasks_MoveInCompletionQualityAudit = "Tom_Tasks_MoveInCompletionQualityAudit",
  Tom_Tasks_OnboardingInspectionTask = "Tom_Tasks_OnboardingInspectionTask",
  Tom_Tasks_OrderGroceriesTask = "Tom_Tasks_OrderGroceriesTask",
  Tom_Tasks_Other = "Tom_Tasks_Other",
  Tom_Tasks_PickupTask = "Tom_Tasks_PickupTask",
  Tom_Tasks_QualityAudit = "Tom_Tasks_QualityAudit",
  Tom_Tasks_QuantityGuestRequest = "Tom_Tasks_QuantityGuestRequest",
  Tom_Tasks_RefundSecurityDeposit = "Tom_Tasks_RefundSecurityDeposit",
  Tom_Tasks_Request = "Tom_Tasks_Request",
  Tom_Tasks_SpaceClean = "Tom_Tasks_SpaceClean",
  Tom_Tasks_TrustAndSafety = "Tom_Tasks_TrustAndSafety",
  Tom_Tasks_TrustAndSafetyEjection = "Tom_Tasks_TrustAndSafetyEjection",
  Tom_Tasks_TrustAndSafetyFollowup = "Tom_Tasks_TrustAndSafetyFollowup",
  Tom_Tasks_TrustAndSafetyRequestToBanGuest = "Tom_Tasks_TrustAndSafetyRequestToBanGuest",
  Tom_Tasks_VipBookingNotification = "Tom_Tasks_VipBookingNotification",
}

export enum UserSortColumn {
  email = "email",
  first_name = "first_name",
  last_name = "last_name",
}

/**
 * Building filters params
 */
export interface BuildingFilterInput {
  city?: string | null;
  activeOnly?: boolean | null;
  ids?: string[] | null;
  internalRefs?: string[] | null;
}

/**
 * Building search filters params
 */
export interface BuildingSearchFilterInput {
  cityIds?: string[] | null;
}

/**
 * Cleaning Company filters params
 */
export interface CleaningCompanyFilterInput {
  active?: boolean | null;
  cityId?: string | null;
  filterFakeCompanies?: boolean | null;
  searchTerm?: string | null;
}

export interface ConnectedSpacesMaintenance {
  subType: ConnectedSpacesMaintenanceTypeEnum;
}

export interface EarlyCheckIn {
  desiredCheckInTime: string;
}

export interface GuestIssue {
  issueType: GuestIssueTypeEnum;
  dropOffLocation?: string | null;
  dropOffTime?: string | null;
  pickUpTime?: string | null;
  guestUrgency?: GuestUrgency | null;
}

export interface GuestRequest {
  requestType: GuestRequestTypeEnum;
  earliestStartTime?: string | null;
  dateToComplete?: string | null;
  dropOffLocation?: string | null;
  dropOffTime?: string | null;
  pickUpTime?: string | null;
  guestUrgency?: GuestUrgency | null;
}

export interface HoldSecurityDeposit {
  securityDepositReason: string;
  securityDepositAmount: number;
}

/**
 * filters
 */
export interface InquiryCheckoutFilterInput {
  cityIds: string[];
  buildingIds?: string[] | null;
  checkOutTimeFrom: any;
  checkOutTimeTo: any;
  checkoutStatuses?: InquiryCheckoutStatus[] | null;
  sameDayOnly?: boolean | null;
}

/**
 * Sort by column
 */
export interface InquiryCheckoutSortInput {
  column: InquiryCheckoutSortColumn;
  order: SortAscDesc;
}

/**
 * Inquiry search filters params
 */
export interface InquirySearchFilterInput {
  cityIds?: string[] | null;
  checkOutStart?: any | null;
  checkOutEnd?: any | null;
  checkInStart?: any | null;
  checkInEnd?: any | null;
}

export interface Inspection {
  googleFormUrl: string;
}

export interface InternalUnitTask {
  subType: InternalUnitTaskSubTypeEnum;
  dropOffLocation?: string | null;
  dropOffTime?: string | null;
  pickUpTime?: string | null;
}

export interface Issue {
  guestUrgency?: GuestUrgency | null;
  permissionToEnter?: FilterPTE | null;
  etaEnabled?: FilterEtaEnabled | null;
}

export interface LateCheckOut {
  desiredCheckOutTime: string;
}

/**
 * Lease Inquiry search filters params
 */
export interface LeaseInquirySearchFilterInput {
  cityIds?: string[] | null;
  startDateStart?: any | null;
  startDateEnd?: any | null;
  endDateStart?: any | null;
  endDateEnd?: any | null;
}

/**
 * How to paginate
 */
export interface Pagination {
  limit: number;
  cursor: string;
}

/**
 * QA email configuration input filters
 */
export interface QaEmailConfigurationFilterInput {
  userIds?: string[] | null;
  companyIds?: string[] | null;
  cityIds?: string[] | null;
}

export interface Request {
  guestUrgency?: GuestUrgency | null;
  permissionToEnter?: FilterPTE | null;
  etaEnabled?: FilterEtaEnabled | null;
  dropOffLocation?: FilterDropOffLocation | null;
  dropOffTime?: string | null;
  pickUpTime?: string | null;
  preferredTimeWindow?: string | null;
  sopExceptionNotes?: string | null;
  quantity?: number | null;
  barSoap?: number | null;
  bathMat?: number | null;
  bodyLotion?: number | null;
  coffeeCreamer?: number | null;
  coffeeFilter?: number | null;
  coffeePacket?: number | null;
  conditioner?: number | null;
  dishwasherPod?: number | null;
  facialTissue?: number | null;
  garbageBagLarge?: number | null;
  garbageBagSmall?: number | null;
  laundryDetergentPod?: number | null;
  oliveOil?: number | null;
  shampoo?: number | null;
  sheetSet?: number | null;
  sugarRegular?: number | null;
  sugarZing?: number | null;
  teaBlack?: number | null;
  teaGreen?: number | null;
  teaMint?: number | null;
  toiletPaper?: number | null;
  towelBath?: number | null;
  towelFacial?: number | null;
  towelHand?: number | null;
  towelPaper?: number | null;
  requestedCleaningDate?: any | null;
  requestedCleaningTimeSlot?: RequestedCleaningTimeSlot | null;
  sourceOfRelocationRequest?: SourceOfRelocationRequest | null;
  reasonForRelocation?: ReasonForRelocation | null;
  detailsOfReasonForRelocation?: string | null;
  preferredRelocationUnit?: string | null;
  fallbackRelocationUnit?: string | null;
  relocationIntendedTime?: any | null;
  followedByGuestServices?: string | null;
}

/**
 * Scheduler metrics input filters
 */
export interface SchedulerMetricsFilterInput {
  assignee?: string[] | null;
  buildingIds?: string[] | null;
  city: string;
  cleaningCompanyIds?: string[] | null;
  cleaningRequestCategory?: CleaningRequestCategory[] | null;
  dueOrLatestEndAt: any;
  sameDayCleansOnly?: boolean | null;
  scheduledOrEarliestStartAt: any;
  scheduleStatus?: TaskScheduleStatusEnum | null;
  status?: FilterStatus[] | null;
  taskType?: TypeEnum[] | null;
}

/**
 * fields to describe user/unit content
 */
export interface SearchFilterInput {
  unit?: UnitSearchFilterInput | null;
  taskContext?: TaskContextSearchFilterInput | null;
  user?: UserSearchFilterInput | null;
  task?: TasksSearchFilterInput | null;
  inquiry?: InquirySearchFilterInput | null;
  leaseInquiry?: LeaseInquirySearchFilterInput | null;
  building?: BuildingSearchFilterInput | null;
  space?: SpaceSearchFilterInput | null;
}

/**
 * Determine the sorting strategy
 */
export interface Sorting {
  column: SortColumn;
  order?: SortAscDesc | null;
}

/**
 * Space search filters params
 */
export interface SpaceSearchFilterInput {
  cityIds?: string[] | null;
}

export interface StructuredMetadataBooking {
  followedByGuestServices?: string | null;
}

/**
 * Task Category filters params
 */
export interface TaskCategoryFilterInput {
  taskTypes?: TypeEnum[] | null;
  locationIds?: string[] | null;
  subjectTypes?: TaskContextSubjectTypeEnum[] | null;
}

/**
 * task context input filters
 */
export interface TaskContextFilterInput {
  taskTypes?: TypeEnum[] | null;
  locationIds?: string[] | null;
  categoryIds?: string[] | null;
  canTaskBeCreatedManually?: boolean | null;
  subjectTypes?: TaskContextSubjectTypeEnum[] | null;
}

/**
 * Tom Task Context search filters params
 */
export interface TaskContextSearchFilterInput {
  taskTypes?: TypeEnum[] | null;
  taskLocationPlaces?: TaskLocationPlaceEnum[] | null;
  subjectTypes?: TaskContextSubjectTypeEnum[] | null;
  canTaskBeCreatedManually?: boolean | null;
}

/**
 * filters
 */
export interface TaskFilterInput {
  city?: string | null;
  status?: FilterStatus[] | null;
  priority?: number[] | null;
  completedAtStart?: any | null;
  completedAtEnd?: any | null;
  createdAtStart?: any | null;
  createdAtEnd?: any | null;
  dueAtStart?: any | null;
  dueAtEnd?: any | null;
  dueOrLatestEndAt?: any | null;
  scheduledOrEarliestStartAt?: any | null;
  triaged?: FilterTriaged | null;
  buildingIds?: string[] | null;
  unitIds?: string[] | null;
  duringStay?: FilterDuringStay | null;
  occupancy?: FilterOccupancy[] | null;
  clientType?: FilterClient | null;
  tomTags?: string[] | null;
  assignee?: string[] | null;
  taskType?: TypeEnum[] | null;
  subjectIds?: string[] | null;
  spaceIds?: string[] | null;
  cleaningRequestCategory?: CleaningRequestCategory[] | null;
}

export interface TaskLocationFilterInput {
  subjectType: TaskContextSubjectTypeEnum;
  subjectId: number;
  taskContextTaskTypes?: TypeEnum[] | null;
}

/**
 * City report filters
 */
export interface TaskMetricsFilterInput {
  cityIds: string[];
  dateEnd: any;
  dateStart: any;
  priorities?: number[] | null;
  taskTypes?: TypeEnum[] | null;
}

/**
 * way to specify recurrence settings
 */
export interface TaskRecurrenceSettingsInput {
  intervalAmt?: number | null;
  intervalUnit?: RecurrenceIntervalUnit | null;
  daysOfWeek?: DaysOfWeek[] | null;
}

/**
 * task scheduler input filters
 */
export interface TaskSchedulerFilterInput {
  assignee?: string[] | null;
  buildingIds?: string[] | null;
  city: string;
  cleaningCompanyIds?: string[] | null;
  cleaningRequestCategory?: CleaningRequestCategory[] | null;
  dueOrLatestEndAt: any;
  scheduledOrEarliestStartAt: any;
  sameDayCleansOnly?: boolean | null;
  status?: FilterStatus[] | null;
  taskType?: TypeEnum[] | null;
  scheduleStatus?: TaskScheduleStatusEnum | null;
}

/**
 * Sort by column
 */
export interface TaskSortInput {
  column: TaskSortColumn;
  order: SortAscDesc;
}

/**
 * Tom Tasks search filters params
 */
export interface TasksSearchFilterInput {
  cityIds?: string[] | null;
  createdAtStart?: any | null;
  createdAtEnd?: any | null;
  statuses?: TaskStatus[] | null;
}

export interface TrustAndSafety {
  reasonForEjection?: ReasonForEjection | null;
  ejectionAt?: any | null;
  guestAlreadyAware?: GuestAlreadyAware | null;
  guestReceivedPreviousWarning?: GuestReceivedPreviousWarning | null;
  securityOnsite?: SecurityOnsite | null;
  reasonForBan?: ReasonForBan | null;
}

export interface TypeStructuredMetadata {
  inspection?: Inspection | null;
  issue?: Issue | null;
  request?: Request | null;
  guestIssue?: GuestIssue | null;
  guestRequest?: GuestRequest | null;
  internalUnitTask?: InternalUnitTask | null;
  connectedSpacesMaintenance?: ConnectedSpacesMaintenance | null;
  trustAndSafety?: TrustAndSafety | null;
  earlyCheckIn?: EarlyCheckIn | null;
  lateCheckOut?: LateCheckOut | null;
  holdSecurityDeposit?: HoldSecurityDeposit | null;
  booking?: StructuredMetadataBooking | null;
}

/**
 * Unit search filters params
 */
export interface UnitSearchFilterInput {
  cityIds?: string[] | null;
}

/**
 * User filters params
 */
export interface UserFilterInput {
  roles?: DispatchRoleName[] | null;
  squads?: SquadTag[] | null;
  cityId?: string | null;
  ids?: string[] | null;
  companyIds?: string[] | null;
}

/**
 * User filters params
 */
export interface UserSearchFilterInput {
  temporaryFakeFilter?: string[] | null;
}

/**
 * Sort by column
 */
export interface UserSortInput {
  column: UserSortColumn;
  order: SortAscDesc;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
